import { SET_ITEM_TO_CALENDAR } from '../actions/itemToCalendar';

const initialState = { item: null };

const itemToCalendarReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ITEM_TO_CALENDAR:
      return {
        ...state,
        item: payload,
      };
    default:
      return state;
  }
};

export default itemToCalendarReducer;
